import { DEFAULT_DATE_FORMAT } from '@moniebook-web/utils';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);

export function isDateValid(dateString: string) {
    return dayjs(dateString, DEFAULT_DATE_FORMAT, true).isValid();
}

export function formatDateTime(
    dateString: string,
    format = 'D MMMM, YYYY · HH:mm',
) {
    return dayjs(dateString).format(format);
}

export function formatTransactionTime(dateString: string): string {
    const transactionDate = dayjs(dateString);
    const today = dayjs().startOf('day');
    const transactionDay = transactionDate.startOf('day');
    const daysDiff = today.diff(transactionDay, 'day');

    const timeFormat = 'h:mm A';

    if (daysDiff === 0) {
        return `Today, ${transactionDate.format(timeFormat)}`;
    }

    if (daysDiff === 1) {
        return `Yesterday, ${transactionDate.format(timeFormat)}`;
    }

    if (daysDiff <= 2) {
        return `${transactionDate.format('ddd')}, ${transactionDate.format(timeFormat)}`;
    }

    return transactionDate.format('Do MMMM YYYY, h:mm A');
}
